import React, { useEffect, useState } from "react"
import styled from "styled-components"
import CardIllust4 from "../../components/CardIllust4"
import SimulationButton from "../../components/SimulationButton"
import MonthPicker from "../../components/MonthPicker"
import Page1 from "./Page1"
import Page2 from "./Page2"
import Page3 from "./Page3"
import PercentageSlider from "../../components/EnergyTrading/PercentageSlider"
import { formatDateToYYYYMM } from "../../util/formatDate"

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  flex: 1 0 0;
  align-self: stretch;
`

const Grid1 = styled.div`
  display: flex;
  width: 334px;
  height: 840px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`

const SimulationBtn = styled.div`
  display: flex;
  padding: 16px 24px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 16px;
  background: var(--secondary80, #4282ef);
  box-shadow: 0px 8px 24px 0px var(--base-black5, rgba(0, 0, 0, 0.05));

  color: var(--base-white100, #fff);
  font-family: SUIT;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

const SimulationFilter = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
  border-radius: 16px;
  background: var(--base-white100, #fff);
  box-shadow: 0px 8px 24px 0px var(--base-black10, rgba(0, 0, 0, 0.1));
`

const DateWrapper = styled.div`
  display: flex;
  width: 124px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`

const MarkText = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  color: var(--base-gray100, #262626);
  font-family: SUIT;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

const SiteWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`

const CheckBoxGroup = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

const CheckBox = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  color: var(--base-gray100, #262626);
  font-family: SUIT;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

const Line = styled.div`
  width: 1px;
  height: 60px;
  background: #d4d4d4;
`

const Frame = styled.div`
  display: flex;
  width: 140px;
  align-items: center;
  align-content: center;
  gap: 16px;
  flex-wrap: wrap;
`

const PercentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`

const Grid2 = styled.div`
  display: flex;
  width: 1440px;
  height: 840px;
  padding: 40px 0px;
  flex-direction: column;
  align-items: flex-start;

  border-radius: 16px;
  border: 1px solid var(--base-gray40, #bfbfbf);
  background: var(--base-white100, #fff);
`

const TabWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
`

const SliderWrapper = styled.div`
  display: flex;
  width: 286px;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`

const PercentGroup = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
`

const PercentGroupItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
`

const Number = styled.div`
  color: var(--base-gray100, #262626);
  font-family: SUIT;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

const Percent = styled.div`
  color: var(--base-gray100, #262626);
  font-family: SUIT;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

interface TabProps {
  selected: boolean
}

const Tab = styled.div<TabProps>`
  display: flex;
  width: 216px;
  height: 44px;
  justify-content: center;
  align-items: center;
  border-radius: 99px;
  background: ${({ selected }) =>
    selected ? "var(--primary70, #3957d3)" : "var(--base-gray20, #d1d1d1)"};
  color: ${({ selected }) =>
    selected ? "var(--base-white100, #fff)" : "var(--base-gray100, #262626)"};
  font-family: SUIT;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s, color 0.3s;
`

const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: #f9f9f9;
  padding: 24px;
`

const LoadingMessage = styled.div`
  color: #555;
  font-family: "SUIT", sans-serif;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 16px;
`

const LoadingAnimation = styled.div`
  width: 150px;
  height: 150px;
  background-image: url("/assets/logo.png"); /* 로딩 아이콘 이미지 */
  background-size: cover; /* 이미지 크기를 div에 맞게 조정 */
  animation: spin 20s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  transform-origin: center; /* 회전의 중심을 설정 */
`

const getPreviousMonth = (): Date => {
  const currentDate = new Date()
  currentDate.setMonth(currentDate.getMonth() - 1) // 이전 월로 설정
  return currentDate
}

const EnergyTrading: React.FC = () => {
  const [selectedMonth, setSelectedMonth] = useState<Date | null>(
    getPreviousMonth()
  )
  const [selectedTab, setSelectedTab] = useState<number>(1) // 탭 상태 관리
  const [대전Data, set대전Data] = useState(null)
  const [보령Data, set보령Data] = useState(null)
  const [여수Data, set여수Data] = useState(null)
  const [정읍Data, set정읍Data] = useState(null)
  const [isReady, setIsReady] = useState<string>("실행전")
  const [rate, setRate] = useState<number>(50)
  const [selectedRate, setSelectedRate] = useState<number>()

  const handleTabClick = async (tabIndex: number) => {
    setSelectedTab(tabIndex)
  }

  const handleSimulationClick = async () => {
    setIsReady("실행중")
    setSelectedRate(rate)

    // selectedMonth와 상태 업데이트 함수는 외부에서 직접 참조
    const formattedMonth = formatDateToYYYYMM(selectedMonth)
    const formattedRate = rate.toString()

    // 날짜가 없는 경우 함수 종료
    if (!formattedMonth) {
      console.error("Selected month is empty.")
      return
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/smart-farm/simulation-data?month=${formattedMonth}&rate=${formattedRate}`
      )
      const data = await response.json()

      // 데이터를 loc로 구분하여 상태 업데이트
      const daejeon = data.result.find((item: any) => item.loc === "대전광역시")
      const boryeong = data.result.find((item: any) => item.loc === "보령시")
      const gunsan = data.result.find((item: any) => item.loc === "군산시")
      const jeongup = data.result.find((item: any) => item.loc === "정읍") || ""

      set대전Data(daejeon)
      set보령Data(boryeong)
      set여수Data(gunsan)
      set정읍Data(jeongup)
      setIsReady("실행완료")
    } catch (error) {
      console.error("Error fetching data:", error)
      setIsReady("실행실패")
    }
  }

  return (
    <Wrapper>
      <Grid1>
        <CardIllust4 />
        <SimulationBtn onClick={handleSimulationClick}>
          시뮬레이션 실행하기
          <SimulationButton />
        </SimulationBtn>
        <SimulationFilter>
          <DateWrapper>
            <MarkText>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="4"
                height="16"
                viewBox="0 0 4 16"
                fill="none"
              >
                <rect width="4" height="16" rx="2" fill="#4282EF" />
              </svg>
              날짜
            </MarkText>
            <MonthPicker
              selectedMonth={selectedMonth}
              setSelectedMonth={setSelectedMonth}
            />
          </DateWrapper>
          {/* <SiteWrapper>
            <MarkText>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="4"
                height="16"
                viewBox="0 0 4 16"
                fill="none"
              >
                <rect width="4" height="16" rx="2" fill="#4282EF" />
              </svg>
              에너지 거래 참여 마을
            </MarkText>
            <CheckBoxGroup>
              <CheckBox>
                <input type="checkbox" />
                전체
              </CheckBox>
              <Line />
              <Frame>
                <CheckBox>
                  <input type="checkbox" />
                  정읍
                </CheckBox>
                <CheckBox>
                  <input type="checkbox" />
                  대전
                </CheckBox>
                <CheckBox>
                  <input type="checkbox" />
                  보령
                </CheckBox>
                <CheckBox>
                  <input type="checkbox" />
                  여수
                </CheckBox>
              </Frame>
            </CheckBoxGroup>
          </SiteWrapper> */}

          <PercentWrapper>
            <MarkText>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="4"
                height="16"
                viewBox="0 0 4 16"
                fill="none"
              >
                <rect width="4" height="16" rx="2" fill="#4282EF" />
              </svg>
              에너지 자립 달성률
            </MarkText>
            <SliderWrapper>
              <PercentageSlider rate={rate} setRate={setRate} />
              <PercentGroup>
                <PercentGroupItem>
                  <Number>50</Number>
                  <Percent>%</Percent>
                </PercentGroupItem>
                <PercentGroupItem>
                  <Number>60</Number>
                  <Percent>%</Percent>
                </PercentGroupItem>
                <PercentGroupItem>
                  <Number>70</Number>
                  <Percent>%</Percent>
                </PercentGroupItem>
                <PercentGroupItem>
                  <Number>80</Number>
                  <Percent>%</Percent>
                </PercentGroupItem>
                <PercentGroupItem>
                  <Number>90</Number>
                  <Percent>%</Percent>
                </PercentGroupItem>
                <PercentGroupItem>
                  <Number>100</Number>
                  <Percent>%</Percent>
                </PercentGroupItem>
              </PercentGroup>
            </SliderWrapper>
          </PercentWrapper>
        </SimulationFilter>
      </Grid1>
      <Grid2>
        {isReady === "실행완료" && (
          <>
            <TabWrapper>
              <Tab
                selected={selectedTab === 1}
                onClick={() => handleTabClick(1)}
              >
                1. 거래 전 현황
              </Tab>
              <Tab
                selected={selectedTab === 2}
                onClick={() => handleTabClick(2)}
              >
                2. 거래결과
              </Tab>
              <Tab
                selected={selectedTab === 3}
                onClick={() => handleTabClick(3)}
              >
                3. 거래 전/후 비교
              </Tab>
            </TabWrapper>
            {/* 선택된 탭에 따라 다른 콘텐츠를 표시 */}
            {selectedTab === 1 && (
              <Page1
                대전Data={대전Data}
                보령Data={보령Data}
                여수Data={여수Data}
                정읍Data={정읍Data}
              />
            )}
            {selectedTab === 2 && (
              <Page2
                대전Data={대전Data}
                보령Data={보령Data}
                여수Data={여수Data}
                정읍Data={정읍Data}
                rate={selectedRate}
              />
            )}
            {selectedTab === 3 && (
              <Page3
                대전Data={대전Data}
                보령Data={보령Data}
                여수Data={여수Data}
                정읍Data={정읍Data}
                rate={selectedRate}
              />
            )}
          </>
        )}
        {isReady === "실행중" && (
          <LoadingWrapper>
            <LoadingMessage>
              시뮬레이션을 실행중입니다... 20초 정도 기다려주세요.
            </LoadingMessage>
            <LoadingAnimation />
          </LoadingWrapper>
        )}
        {isReady === "실행전" && (
          <LoadingWrapper>
            <LoadingMessage>
              날짜와 목표 자립률을 선택한 뒤 시뮬레이션 실행을 눌러주세요.
            </LoadingMessage>
          </LoadingWrapper>
        )}
        {isReady === "실행실패" && (
          <LoadingWrapper>
            <LoadingMessage>
              시뮬레이션 실행에 실패했습니다. 날짜 및 서버 상태를 확인해주세요
            </LoadingMessage>
          </LoadingWrapper>
        )}
      </Grid2>
    </Wrapper>
  )
}

export default EnergyTrading
